import {
  MultiplexNormalizationJobParams,
  NormalizationMethod,
  TilePercentileCaps,
} from 'interfaces/jobs/multiplex/normalizationParams';
import { StainType } from 'interfaces/stainType';
import { fromPairs, isEmpty, map } from 'lodash';
import { getDnaChannelNames } from './channelSelection';

export const DNA_TILE_PERCENTILE_CAPS: TilePercentileCaps = {
  minCUpperPercentile: 0.01,
  maxCUpperPercentile: 0.999,
};

export const DNA_TILE_PERCENTILE_CAPS_REQUIRED_MESSAGE =
  'Select at least one DNA channel to apply DNA tile percentile caps';

export const isDnaTilePercentileCapsValid = ({
  enabled,
  method,
  channels,
  stainTypeOptions = [],
}: {
  enabled?: boolean;
  method?: NormalizationMethod | string;
  channels?: MultiplexNormalizationJobParams['channels'];
  stainTypeOptions?: StainType[];
}): boolean => {
  if (!enabled || method !== NormalizationMethod.Auto) {
    return true;
  }

  return !isEmpty(
    getDnaChannelNames(
      map(channels, (channel) => String(channel)),
      stainTypeOptions
    )
  );
};

export const buildDnaTilePercentileCaps = ({
  enabled,
  method,
  channels,
  stainTypeOptions = [],
}: {
  enabled?: boolean;
  method?: NormalizationMethod;
  channels?: MultiplexNormalizationJobParams['channels'];
  stainTypeOptions?: StainType[];
}): Record<string, TilePercentileCaps> | undefined => {
  if (!enabled || method !== NormalizationMethod.Auto) {
    return undefined;
  }

  const dnaChannelNames = getDnaChannelNames(
    map(channels, (channel) => String(channel)),
    stainTypeOptions
  );

  if (isEmpty(dnaChannelNames)) {
    return undefined;
  }

  return fromPairs(map(dnaChannelNames, (channelName) => [channelName, DNA_TILE_PERCENTILE_CAPS]));
};
